/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { ReactNode, useState } from "react";

const PageContext = React.createContext([[], () => {}]);

function PageProvider({
  children,
  initialValues,
}: {
  children: ReactNode;
  initialValues: any;
}) {
  const [state, setState] = useState<any>(initialValues || {});
  return (
    <PageContext.Provider value={[state, setState]}>
      {children}
    </PageContext.Provider>
  );
}

export { PageContext, PageProvider };
